import React, { ReactNode } from 'react'

import Logo from '../Logo'

type HeaderProps = {
  children?: ReactNode
}
const Header: React.FC = ({ children }: HeaderProps) => {
  return (
    <div className="relative top-0 flex h-[90px] justify-center bg-white px-[100px] mb-[35px] shadow-[0px_2px_4px_rgba(0,0,0,0.05),0px_6px_12px_rgba(61,69,67,0.05)] max-[766px]:h-[70px] max-[766px]:mb-[20px]">
      <div className="relative mx-auto flex w-full max-w-[500px] flex-col items-center justify-center max-[766px]:scale-90">
        <div className="absolute left-[30px]">{children}</div>
        <Logo />
      </div>
    </div>
  )
}

export default Header
